import { render } from "./create_appointment.vue?vue&type=template&id=598dd4fd&scoped=true"
import script from "./create_appointment.vue?vue&type=script&lang=js"
export * from "./create_appointment.vue?vue&type=script&lang=js"

import "./create_appointment.vue?vue&type=style&index=0&id=598dd4fd&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598dd4fd"]])

export default __exports__